"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userAgentsInclude = exports.useCombinedRefs = exports.stripHtml = exports.isMobileDevice = exports.getScrollClient = exports.getParentsScrollTop = exports.getParentsClasses = exports.getHasScroll = exports.SCREEN_PADDING = exports.ClassNames = exports.ClassList = void 0;
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SCREEN_PADDING = exports.SCREEN_PADDING = 8; // px

const ClassNames = function () {
  for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
    props[_key] = arguments[_key];
  }
  return props.map(i => Array.isArray(i) ? i.join(' ') : i).filter(i => !!i).join(' ');
};
exports.ClassNames = ClassNames;
const ClassList = name => !name ? [] : name.split(' ').map(item => item.trim()).filter(item => item);
exports.ClassList = ClassList;
const getParentsClasses = function (element) {
  let names = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  let target = element;
  let classes = [];
  let found = false;
  while (!found && target && target.parentNode) {
    if (target.classList &&
    // svg path doesnt have classList
    target.classList.length) {
      classes = [...classes, ...target.classList];
      if (names) {
        for (let i = 0; i < names.length; i++) {
          if (classes.includes(names[i])) {
            found = true;
            break;
          }
        }
      }
    }
    target = target.parentNode;
  }
  return classes;
};
exports.getParentsClasses = getParentsClasses;
const getHasScroll = element => {
  let target = element;
  let x = false;
  let y = false;
  while (!x && !y && target && target.parentNode) {
    if (target.scrollWidth > target.clientWidth) {
      x = true;
    }
    if (target.scrollHeight > target.clientHeight) {
      y = true;
    }
    target = target.parentNode;
  }
  return {
    x,
    y
  };
};
exports.getHasScroll = getHasScroll;
const isMobileDevice = () => typeof window.orientation !== 'undefined' || navigator.userAgent.indexOf('IEMobile') !== -1;
exports.isMobileDevice = isMobileDevice;
const userAgentsInclude = agents => {
  const ua = navigator.userAgent.toLowerCase();
  let includes = false;
  agents.forEach(agent => {
    if (ua.includes(agent)) {
      if (agent === 'safari' && ua.includes('chrome')) {
        // we caught you, chrome
      } else {
        includes = true;
      }
    }
  });
  return includes;
};
exports.userAgentsInclude = userAgentsInclude;
const getScrollClient = () => {
  const body = document.body;
  const docEl = document.documentElement;
  return {
    scrollLeft: window.pageXOffset || docEl.scrollLeft || body.scrollLeft,
    scrollTop: window.pageYOffset || docEl.scrollTop || body.scrollTop,
    clientLeft: docEl.clientLeft || body.clientLeft || 0,
    clientTop: docEl.clientTop || body.clientTop || 0
  };
};
exports.getScrollClient = getScrollClient;
const getParentsScrollTop = element => {
  let target = element;
  while (target && target.parentNode) {
    if (target.scrollTop) return target.scrollTop;
    target = target.parentNode;
  }
  return 0;
};
exports.getParentsScrollTop = getParentsScrollTop;
const useCombinedRefs = function () {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  const targetRef = React.useRef();
  React.useEffect(() => {
    refs.forEach(ref => {
      if (!ref) return;
      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else {
        ref.current = targetRef.current;
      }
    });
  }, [refs]);
  return targetRef;
};
exports.useCombinedRefs = useCombinedRefs;
const stripHtml = html => {
  if (!html) return html;
  const htmlFree = html.replace(/<[^>]*>/g, ' ');
  return htmlFree;
};
exports.stripHtml = stripHtml;